export default __webpack_public_path__ + "static/media/vwing.af6bedb4.svg";